import React, { useState, useEffect, useMemo } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import TrackRightLogo from "../../../assets/images/logo-white.svg";
import trackrightlogo from "../../../assets/images/trackryticon.svg";
import { setSubscriptionList } from "../../../Redux/AuthSlice";
import TrackRightLogoTxt from "../../../assets/images/TrackRight.png";
import HomeIcon from "../../../assets/images/home-angle-2-svgrepo-com.png";
import DashboardIcon from "../../../assets/images/dashboard-svgrepo-com.png";
import CustDashIcon from "../../../assets/images/dashboard-tile-setting-solid-svgrepo-com.png";
import TrackIcon from "../../../assets/images/navigation.png";
import OperationIcon from "../../../assets/images/check-square-svgrepo-com.png";
import ReportsIcon from "../../../assets/images/document-svgrepo-com.png";
import AdministrationIcon from "../../../assets/images/organization-svgrepo-com.png";
import AnalyticsIcon from "../../../assets/images/chart-pipe-svgrepo-com 1.png";
import ContainerTrackingIcon from "../../../assets/images/octicon_container-16.svg";
// import{ReactComponent as ContainerTrackingIcon }  from "../../../assets/images/octicon_container-16.svg";

import NotificationIcon from "../../../assets/images/Vector.png";
import AlertIcon from "../../../assets/images/alert-triangle-svgrepo-com (1).png";
import ProfileIcon from "../../../assets/livetracking/profileiconn.svg";
import ProfileIconresponive from "../../../assets/livetracking/profileiconresponive.svg";
import { useLocation } from "react-router-dom";
import logohead from "../../../assets/images/logohead.png";
import LayoutWrap from "./style";
import {
  Button,
  Layout,
  Menu,
  theme,
  Drawer,
  Form,
  Input,
  message,
} from "antd";
import { UIModal } from "../../../Reusablecomponents/UIModal";
import { ButtonFilled } from "../../../Reusablecomponents/UIButtons";
import {
  RightOutlined,
  LeftOutlined,
  MenuOutlined,
  CloseOutlined,
  LogoutOutlined,
  LockOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import alert from "../../../assets/images/alerticon.svg";
import notify from "../../../assets/images/notify.svg";
import profile from "../../../assets/images/profileicon.svg";
import { Dropdown, Tooltip } from "antd";
import { CALL_API } from "../../../Common/api";
import { useDispatch, useSelector } from "react-redux";
import { set } from "immutable";
import { icon } from "leaflet";
import styled from "styled-components";
import LiveMapcomponent from "../../../containers/LiveTrack/LiveMapcomponent";

const { Header, Sider, Content } = Layout;

/** Handles both `{ data: [...] }` and plain array responses from subscription APIs. */
function parseSubscriptionRows(apiResult) {
  if (!apiResult) return [];
  if (Array.isArray(apiResult)) return apiResult;
  if (Array.isArray(apiResult.data)) return apiResult.data;
  return [];
}

function filterMenu(items, allowedSecCodes) {
  if (!Array.isArray(items) || !items.length) return [];
  const allowAllBySubscription =
    !Array.isArray(allowedSecCodes) || allowedSecCodes.length === 0;
  return items
    .filter((menu) => {
      if (!menu) return false;
      if (allowAllBySubscription) return true;
      if (!menu.SECCODE || menu.SECCODE.trim() === "") return true;
      const secArray = menu.SECCODE.split("!").map((s) =>
        s.trim().toUpperCase(),
      );
      return secArray.some((code) => allowedSecCodes.includes(code));
    })
    .map((menu) => {
      if (menu.children) {
        const filteredChildren = filterMenu(menu.children, allowedSecCodes);
        if (filteredChildren.length > 0) {
          return { ...menu, children: filteredChildren };
        }
        return null;
      }
      return menu;
    })
    .filter(Boolean);
}

const Customstyle = styled.div`
  .trackrightAicargo {
    width: 20px;
    height: 15px;
    fill: lightgray !important;
  }
`;

const Mainindex = () => {
  const dispatch = useDispatch();
  const navigatenotify = useNavigate();
  const handleClicknotify = () => {
    navigatenotify("/Notification");
  };
  const [collapsed, setCollapsed] = useState(false);
  console.log(collapsed, "collapsed");
  const currentPath = window.location.pathname;
  //  window.open(`/tracklink/${tripId}`, "_blank", "noopener,noreferrer");
  console.log(currentPath === "/tracklink", "currentPath");
  // const hideLayout = window.location.pathname === "/tracklink";
  const hideLayout = window.location.pathname.includes("/tracklink");
  const hideAILayout = window.location.pathname.includes("/TrackLinkAI");
  const hideNexusLayout =
    window.location.pathname.includes("/nexusTrackLinkAI");
  const hideContainerLayout = window.location.pathname.includes("/tripTrack");
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const isNexusMenuUser =
    Number(userInfo?.MCID) === 59 || Boolean(userInfo?.NexusCompId);
  // TraKing-linked accounts (any company with a NexusCompId) use the Nexus menus; the standard
  // TrackRight AI menus and iCloud geofence management would only confuse them.
  const usesTraking =
    Boolean(userInfo?.NexusCompId) && Number(userInfo?.MCID) !== 59;
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const homeAIPlusRead = useMemo(
    () => hasPermission("AIPLS_HME", "R"),
    [reduxPermissions],
  );
  const homeAIRead = useMemo(
    () => hasPermission("AI_HME", "R"),
    [reduxPermissions],
  );
  const homeContRead = useMemo(
    () => hasPermission("CONT_HME", "R"),
    [reduxPermissions],
  );
  const dashAIRead = useMemo(
    () => hasPermission("AI_DASH", "R"),
    [reduxPermissions],
  );
  const dashAIPRead = useMemo(
    () => hasPermission("AIPLS_DSH", "R"),
    [reduxPermissions],
  );
  const dashCargoRead = useMemo(
    () => hasPermission("CONT_DASH", "R"),
    [reduxPermissions],
  );
  const custRead = useMemo(
    () => hasPermission("CUSTDASH", "R"),
    [reduxPermissions],
  );
  const custAIRead = useMemo(
    () => hasPermission("AICUSTDASH", "R"),
    [reduxPermissions],
  );
  const liveRead = useMemo(
    () => hasPermission("LIVE", "LR"),
    [reduxPermissions],
  );

  const contRegRead = useMemo(
    () => hasPermission("CONT_REG", "R"),
    [reduxPermissions],
  );

  const tripMonitorRead = useMemo(
    () => hasPermission("TRPMONITOR", "R"),
    [reduxPermissions],
  );
  const cargoTripReportRead = useMemo(
    () => hasPermission("CONT_TRPT", "R"),
    [reduxPermissions],
  );
  const cargoKPIReportRead = useMemo(
    () => hasPermission("CONT_KRPT", "R"),
    [reduxPermissions],
  );
  const cargoCarbonReportRead = useMemo(
    () => hasPermission("CONT_CRPT", "R"),
    [reduxPermissions],
  );
  const tripAIRead = useMemo(
    () => hasPermission("TRIPAI", "R"),
    [reduxPermissions],
  );
  const consignAIRead = useMemo(
    () => hasPermission("CONSIGNAI", "R"),
    [reduxPermissions],
  );
  const fuelAIRead = useMemo(
    () => hasPermission("FUELAI", "R"),
    [reduxPermissions],
  );
  const tripAIReportRead = useMemo(
    () => hasPermission("AITRPT", "R"),
    [reduxPermissions],
  );
  const vehicleAIReportRead = useMemo(
    () => hasPermission("AIVRPT", "R"),
    [reduxPermissions],
  );
  const tripBreakAIReportRead = useMemo(
    () => hasPermission("AITRBRPT", "R"),
    [reduxPermissions],
  );
  const tripAllAIReportRead = useMemo(
    () => hasPermission("AITARPT", "R"),
    [reduxPermissions],
  );
  const carbonAIReportRead = useMemo(
    () => hasPermission("AITCFRPT", "R"),
    [reduxPermissions],
  );
  const fuelAIReportRead = useMemo(
    () => hasPermission("AIFUELRPT", "R"),
    [reduxPermissions],
  );
  const custAIReportRead = useMemo(
    () => hasPermission("AICUSTRPT", "R"),
    [reduxPermissions],
  );
  const kpiAIReportRead = useMemo(
    () => hasPermission("AIKPI_RPT", "R"),
    [reduxPermissions],
  );
  const tripReportRead = useMemo(
    () => hasPermission("TRPT", "R"),
    [reduxPermissions],
  );
  const vehicleReportRead = useMemo(
    () => hasPermission("VRPT", "R"),
    [reduxPermissions],
  );
  const tripBreakReportRead = useMemo(
    () => hasPermission("TRBRPT", "R"),
    [reduxPermissions],
  );
  const tripAllReportRead = useMemo(
    () => hasPermission("TARPT", "R"),
    [reduxPermissions],
  );
  const carbonReportRead = useMemo(
    () => hasPermission("TCFRPT", "R"),
    [reduxPermissions],
  );
  const fuelReportRead = useMemo(
    () => hasPermission("FUELRPT", "R"),
    [reduxPermissions],
  );
  const custReportRead = useMemo(
    () => hasPermission("CUSTRPT", "R"),
    [reduxPermissions],
  );
  const kpiReportRead = useMemo(
    () => hasPermission("KPIREPORT", "R"),
    [reduxPermissions],
  );
  const tripRead = useMemo(
    () => hasPermission("TRIP", "R"),
    [reduxPermissions],
  );
  const consignRead = useMemo(
    () => hasPermission("CONSIGN", "R"),
    [reduxPermissions],
  );
  const fuelRead = useMemo(
    () => hasPermission("FUEL", "R"),
    [reduxPermissions],
  );
  const userRead = useMemo(() => hasPermission("USR", "R"), [reduxPermissions]);
  const roleRead = useMemo(
    () => hasPermission("ROLE", "R"),
    [reduxPermissions],
  );
  const entityRead = useMemo(
    () => hasPermission("CENTITY", "R"),
    [reduxPermissions],
  );
  const tentityRead = useMemo(
    () => hasPermission("TENTITY", "R"),
    [reduxPermissions],
  );
  const CeentityRead = useMemo(
    () => hasPermission("CE_ENTITY", "R"),
    [reduxPermissions],
  );
  const officeRead = useMemo(
    () => hasPermission("OFFICE", "R"),
    [reduxPermissions],
  );
  const vehicleRead = useMemo(
    () => hasPermission("VEHICLE", "R"),
    [reduxPermissions],
  );
  const vehTypeRead = useMemo(
    () => hasPermission("VCHTYPE", "R"),
    [reduxPermissions],
  );
  const companyRead = useMemo(
    () => hasPermission("MASTERCOMP", "R"),
    [reduxPermissions],
  );
  const mailRead = useMemo(
    () => hasPermission("SENTEMAIL", "R"),
    [reduxPermissions],
  );
  const evActRead = useMemo(
    () => hasPermission("EVACTIONS", "R"),
    [reduxPermissions],
  );
  const cusFieldRead = useMemo(
    () => hasPermission("CUSTFIELD", "R"),
    [reduxPermissions],
  );
  const mKpiRead = useMemo(() => hasPermission("KPI", "R"), [reduxPermissions]);
  const tSubRead = useMemo(
    () => hasPermission("SUBSCRIBE", "R"),
    [reduxPermissions],
  );
  const geoRead = useMemo(() => hasPermission("GEO", "R"), [reduxPermissions]);
  const routeRead = useMemo(
    () => hasPermission("ROUTE", "R"),
    [reduxPermissions],
  );

  const opDashRead = useMemo(
    () => hasPermission("OP_DASH", "R"),
    [reduxPermissions],
  );

  const item = [
    (homeAIRead || homeAIPlusRead || homeContRead) && {
      key: "1",
      icon: <img src={HomeIcon} alt="home" />,
      label: "Home",
      path: "/Home",
      SECCODE: "AIPLS_HME ! AI_HME ! CONT_HME",
    },
    (dashAIPRead || dashAIRead || dashCargoRead) && {
      key: "2",
      icon: <img src={DashboardIcon} alt="dashboard" />,
      label: "Dashboard",
      path: "/Dashboard",
      SECCODE: "AIPLS_DSH ! AI_DASH ! CONT_DASH",
    },
    // {
    //   key: "3",
    //   icon: <img src={CustDashIcon} alt="custdashboard" />,
    //   label: "Custom Dashboard",
    //   path: "/customDashboard",
    //   SECCODE: "CUSTDASH",
    // },
    opDashRead && {
      key: "3",
      icon: <img src={DashboardIcon} alt="dashboard" />,
      label: "Operation Dashboard",
      path: "/nexusDashboardAI",
      SECCODE: "OP_DASH",
    },
    (custRead || custAIRead) && {
      key: "4",
      icon: <img src={CustDashIcon} alt="custdashboard" />,
      label: "Custom Dashboard",
      path: "/customDashboardAI",
      SECCODE: "CUSTDASH ! AICUSTDASH",
    },
    contRegRead && {
      key: "14",
      icon: <img src={CustDashIcon} alt="custdashboard" />,
      label: "Container Register",
      path: "/containerRegister",
      SECCODE: "CONT_REG",
    },
    //   {
    //   key: "4",
    //   icon: <img src={TrackIcon} alt="Live Tracking" />,
    //   label: "Live Tracking",
    //   path: "/liveTrackingMain",
    //   SECCODE: "LIVETRACKMAIN",
    // },
    liveRead && {
      key: "4",
      icon: <img src={TrackIcon} alt="Tracking" />,
      label: "Live Tracking",
      path: "/liveTrackingMaincontainer",
      SECCODE: "",
      children: [
        liveRead && {
          key: "4-1",
          label: "Live",
          path: "/liveTrackingMaincontainer",
          SECCODE: "LIVE",
        },
        {
          key: "4-2",
          label: "History",
          path: "/liveTrackinghistory",
          SECCODE: "HSTY",
        },
        // {
        //   key: "4-3",
        //   label: "Workshop",
        //   path: "/Workshop",
        //   SECCODE: "",
        // },
      ],
    },
    !usesTraking &&
      (tripMonitorRead || cargoKPIReportRead || cargoCarbonReportRead) && {
        key: "5",
        icon: <img src={ContainerTrackingIcon} alt="operation" />,
        label: "TrackRight AI Cargo",
        path: "/",
        SECCODE: "",
        children: [
          tripMonitorRead && {
            key: "5-1",
            label: "Trip Monitoring",
            path: "/tripMonitoring",
            SECCODE: "TRPMONITOR",
          },
          (cargoTripReportRead ||
            cargoKPIReportRead ||
            cargoCarbonReportRead) && {
            key: "5-2",
            label: "AI Cargo Reports",
            path: "/containerReports",
            SECCODE: "CONT_TRPT ! CONT_KRPT ! CONT_CRPT",
          },
        ],
      },
    !usesTraking &&
      (tripAIRead ||
        consignAIRead ||
        fuelAIRead ||
        tripAIReportRead ||
        vehicleAIReportRead ||
        tripBreakAIReportRead ||
        tripAllAIReportRead ||
        custAIReportRead ||
        carbonAIReportRead ||
        fuelAIReportRead ||
        kpiAIReportRead) && {
        key: "6",
        icon: <img src={OperationIcon} alt="operation" />,
        label: "TrackRight AI",
        path: "",
        SECCODE: "",
        children: [
          consignAIRead && {
            key: "6-1",
            label: "Consignment",
            path: "/consignmentAI",
            SECCODE: "CONSIGNAI",
          },
          tripAIRead && {
            key: "6-2",
            label: "Trip List",
            path: "/tripListAI",
            SECCODE: "TRIPAI",
          },
          fuelAIRead && {
            key: "6-3",
            label: "Fuel Entry",
            path: "/fuelEntryAI",
            SECCODE: "FUELAI",
          },
          {
            key: "6-4",
            icon: <img src={ReportsIcon} alt="AIreports" />,
            label: "AI Reports",
            path: "",
            SECCODE: "",
            children: [
              tripAIReportRead && {
                key: "6-4-1",
                label: "Trip Report",
                path: "/AItripreport",
                SECCODE: "AITRPT",
              },
              vehicleAIReportRead && {
                key: "6-4-2",
                label: "Vehicle Report",
                path: "/AIvehiclereport",
                SECCODE: "AIVRPT",
              },
              custAIReportRead && {
                key: "6-4-3",
                label: "Customer Report",
                path: "/AIcustomerreport",
                SECCODE: "AICUSTRPT",
              },
              kpiAIReportRead && {
                key: "6-4-4",
                label: "KPI Report",
                path: "/AIkpi report",
                SECCODE: "AIKPI_RPT",
              },
              tripBreakAIReportRead && {
                key: "6-4-5",
                label: "Trip Break Report",
                path: "/AITripbreakreport",
                SECCODE: "AITRBRPT",
              },
              tripAllAIReportRead && {
                key: "6-4-6",
                label: "Trip Allowance",
                path: "/AITripAllowance",
                SECCODE: "AITARPT",
              },
              carbonAIReportRead && {
                key: "6-4-7",
                label: "Carbon Footprint",
                path: "/AICarbonfootprints",
                SECCODE: "AITCFRPT",
              },
              fuelAIReportRead && {
                key: "6-4-8",
                label: "Fuel Report",
                path: "/AIfuelreport",
                SECCODE: "AIFUELRPT",
              },
            ],
          },
        ],
      },
    // {
    //   key: "7",
    //   icon: <img src={TrackIcon} alt="tracking" />,
    //   label: "Tracking",
    //   path: "/tracking",
    //   children: [
    //     {
    //       key: "7-1",
    //       label: "Live Tracking",
    //       path: "/livetracking",
    //       SECCODE: "TRACK",
    //     },
    //     {
    //       key: "7-2",
    //       label: "Track",
    //       path: "/tracking-track",
    //       SECCODE: "TRACK",
    //     },
    //     {
    //       key: "7-3",
    //       label: "Geo-Fensing",
    //       path: "/tracking-geo-fensing",
    //       SECCODE: "GEOFENCING",
    //     },
    //   ],
    // },
    !usesTraking &&
      (consignRead ||
        tripRead ||
        fuelRead ||
        tripReportRead ||
        vehicleReportRead ||
        tripBreakReportRead ||
        tripAllReportRead ||
        custReportRead ||
        carbonReportRead ||
        fuelReportRead ||
        kpiReportRead) && {
        key: "8",
        icon: <img src={OperationIcon} alt="operation" />,
        label: "TrackRight AI+",
        path: "/operations",
        children: [
          consignRead && {
            key: "8-1",
            label: "Consignment",
            path: "/Consignment1",
            SECCODE: "CONSIGN",
          },
          tripRead && {
            key: "8-2",
            label: "Trip List",
            path: "/TripList1",
            SECCODE: "TRIP",
          },
          fuelRead && {
            key: "8-3",
            label: "Fuel Entry",
            path: "/FuelEntry1",
            SECCODE: "FUEL",
          },
          {
            key: "8-4",
            icon: <img src={ReportsIcon} alt="reports" />,
            label: "Reports",
            path: "/reports",
            children: [
              tripReportRead && {
                key: "8-4-1",
                label: "Trip Report",
                path: "/tripreport",
                SECCODE: "TRPT",
              },
              vehicleReportRead && {
                key: "8-4-2",
                label: "Vehicle Report",
                path: "/vehiclereport",
                SECCODE: "VRPT",
              },
              custReportRead && {
                key: "8-4-3",
                label: "Customer Report",
                path: "/customerreport",
                SECCODE: "CUSTRPT",
              },
              kpiReportRead && {
                key: "8-4-4",
                label: "KPI Report",
                path: "/reports/kpi report",
                SECCODE: "KPIREPORT",
              },
              tripBreakReportRead && {
                key: "8-4-5",
                label: "Trip Break Report",
                path: "/Tripbreakreport",
                SECCODE: "TRBRPT",
              },
              tripAllReportRead && {
                key: "8-4-6",
                label: "Trip Allowance",
                path: "/TripAllowance",
                SECCODE: "TARPT",
              },
              carbonReportRead && {
                key: "8-4-7",
                label: "Carbon Footprint",
                path: "/Carbonfootprints",
                SECCODE: "TCFRPT",
              },
              fuelReportRead && {
                key: "8-4-8",
                label: "Fuel Report",
                path: "/fuelreport",
                SECCODE: "FUELRPT",
              },
            ],
          },
        ],
      },
    // {
    //   key: "9",
    //   icon: <img src={ReportsIcon} alt="reports" />,
    //   label: "Reports",
    //   path: "/reports",
    //   children: [
    //     {
    //       key: "9-1",
    //       label: "Trip Report",
    //       path: "/tripreport",
    //       SECCODE: "TRPT",
    //     },

    //     {
    //       key: "9-2",
    //       label: "Vehicle Report",
    //       path: "/vehiclereport",
    //       SECCODE: "VRPT",
    //     },
    //     {
    //       key: "9-3",
    //       label: "Customer Report",
    //       path: "/customerreport",
    //       SECCODE: "CUSTRPT",
    //     },

    //     {
    //       key: "9-4",
    //       label: "KPI Report",
    //       path: "/reports/kpi report",
    //       SECCODE: "KPIREPORT",
    //     },
    //     {
    //       key: "9-5",
    //       label: "Trip Break Report",
    //       path: "/Tripbreakreport",
    //       SECCODE: "TRBRPT",
    //     },
    //     {
    //       key: "9-6",
    //       label: "Trip Allowance",
    //       path: "/TripAllowance",
    //       SECCODE: "TARPT",
    //     },
    //     {
    //       key: "9-7",
    //       label: "Carbon Footprint",
    //       path: "/Carbonfootprints",
    //       SECCODE: "TCFRPT",
    //     },
    //     {
    //       key: "9-8",
    //       label: "Fuel Report",
    //       path: "/fuelreport",
    //       SECCODE: "FUELRPT",
    //     },
    //   ],
    // },
    // {
    //   key: "10",
    //   icon: <img src={ReportsIcon} alt="AIreports" />,
    //   label: "AI Reports",
    //   path: "",
    //   SECCODE: "",
    //   children: [
    //     {
    //       key: "10-1",
    //       label: "Trip Report",
    //       path: "/AItripreport",
    //       SECCODE: "AITRPT",
    //     },

    //     {
    //       key: "10-2",
    //       label: "Vehicle Report",
    //       path: "/AIvehiclereport",
    //       SECCODE: "AIVRPT",
    //     },
    //     {
    //       key: "10-3",
    //       label: "Customer Report",
    //       path: "/AIcustomerreport",
    //       SECCODE: "AICUSTRPT",
    //     },

    //     {
    //       key: "10-4",
    //       label: "KPI Report",
    //       path: "/AIkpi report",
    //       SECCODE: "AIKPIREPORT",
    //     },
    //     {
    //       key: "10-5",
    //       label: "Trip Break Report",
    //       path: "/AITripbreakreport",
    //       SECCODE: "AITRBRPT",
    //     },
    //     {
    //       key: "10-6",
    //       label: "Trip Allowance",
    //       path: "/AITripAllowance",
    //       SECCODE: "AITARPT",
    //     },
    //     {
    //       key: "10-7",
    //       label: "Carbon Footprint",
    //       path: "/AICarbonfootprints",
    //       SECCODE: "AITCFRPT",
    //     },
    //     {
    //       key: "10-8",
    //       label: "Fuel Report",
    //       path: "/AIfuelreport",
    //       SECCODE: "AIFUELRPT",
    //     },
    //   ],
    // },
    (userRead ||
      entityRead ||
      tentityRead ||
      CeentityRead ||
      roleRead ||
      mKpiRead ||
      mailRead ||
      officeRead ||
      vehTypeRead ||
      vehicleRead ||
      cusFieldRead ||
      evActRead ||
      companyRead ||
      geoRead ||
      routeRead ||
      tSubRead) && {
      key: "11",
      icon: <img src={AdministrationIcon} alt="administration" />,
      label: "Administration",
      path: "/Administration",
      children: [
        geoRead &&
          !usesTraking && {
            key: "11-0",
            label: "Geofence Management",
            path: "/GeoFence",
            SECCODE: "GEO",
          },
        routeRead && {
          key: "11-1",
          label: "Route Management",
          path: "/Route",
          SECCODE: "ROUTE",
        },
        (entityRead || tentityRead || CeentityRead) && {
          key: "11-2",
          label: "Entity Management",
          path: "/entitymanagement ",
          SECCODE: "CENTITY ! TENTITY ! CE_ENTITY",
        },
        userRead && {
          key: "11-3",
          label: "User Management",
          path: "/UserManagement",
          SECCODE: "USR",
        },
        roleRead && {
          key: "11-4",
          label: "Role Management",
          path: "/Roles",
          SECCODE: "ROLE",
        },
        (officeRead ||
          vehTypeRead ||
          vehicleRead ||
          evActRead ||
          cusFieldRead) && {
          key: "11-5",
          label: "Master Tables",
          path: "/MasterTable",
          SECCODE: "OFFICE ! VCHTYPE ! VEHICLE ! EVACTIONS ! CUSTFIELD",
        },
        mailRead && {
          key: "11-6",
          label: "Email Log",
          path: "/EmailLog ",
          SECCODE: "SENTEMAIL",
        },
        {
          key: "11-7",
          label: "SMS Log",
          path: "/SmsLog ",
          SECCODE: "SMS",
        },
        // Show only if SYSADM
        userInfo?.UID === 2 && {
          key: "11-8",
          label: "Master Company",
          path: "/MasterCompany",
          SECCODE: "MASTERCOMP",
        },
        userInfo?.UID === 2 && {
          key: "11-9",
          label: "Tenant Subscription",
          path: "/TenantSubscription",
          SECCODE: "SUBSCRIBE",
        },
        mKpiRead && {
          key: "11-10",
          label: "KPI Master",
          path: "/kpimaster",
          SECCODE: "KPI",
        },
      ],
    },

    //NEXUS
    // Nexus menus are for MCID 59 and any company with a NexusCompId
    isNexusMenuUser &&
      (tripMonitorRead || cargoKPIReportRead || cargoCarbonReportRead) && {
        key: "12",
        icon: <img src={ContainerTrackingIcon} alt="operation" />,
        label: "Nexus - AI Cargo",
        path: "/",
        SECCODE: "",
        children: [
          tripMonitorRead && {
            key: "12-1",
            label: "Trip Monitoring",
            path: "/tripMonitoring",
            SECCODE: "TRPMONITOR",
          },
          // !cargoTripReportRead && !cargoKPIReportRead && !cargoCarbonReportRead && {
          //   key: "12-2",
          //   label: "AI Cargo Reports",
          //   path: "/containerReports",
          //   SECCODE: "CONT_TRPT ! CONT_KRPT ! CONT_CRPT",
          // },
        ],
      },
    isNexusMenuUser &&
      (tripAIRead ||
        consignAIRead ||
        fuelAIRead ||
        tripAIReportRead ||
        vehicleAIReportRead ||
        tripBreakAIReportRead ||
        tripAllAIReportRead ||
        custAIReportRead ||
        carbonAIReportRead ||
        fuelAIReportRead ||
        kpiAIReportRead) && {
        key: "13",
        icon: <img src={OperationIcon} alt="operation" />,
        label: "Nexus - TrackRight AI",
        path: "",
        SECCODE: "",
        children: [
          consignAIRead && {
            key: "13-1",
            label: "Consignment",
            path: "/nexusConsignAI",
            SECCODE: "CONSIGNAI",
          },
          tripAIRead && {
            key: "13-2",
            label: "Trip List",
            path: "/nexusTripListAI",
            SECCODE: "TRIPAI",
          },
          fuelAIRead && {
            key: "13-3",
            label: "Fuel Entry",
            path: "/nexusFuelEntryAI",
            SECCODE: "FUELAI",
          },
          geoRead && {
            key: "13-4",
            label: "Nexus - Geofence Mgt",
            path: "/NexusGeoFence",
            SECCODE: "GEO",
          },
          // routeRead && {
          //   key: "13-5",
          //   label: "Nexus - Route Mgt",
          //   path: "/Route",
          //   SECCODE: "ROUTE",
          // },
          // {
          //   key: "13-4",
          //   icon: <img src={ReportsIcon} alt="AIreports" />,
          //   label: "AI Reports",
          //   path: "",
          //   SECCODE: "",
          //   children: [
          //     {
          //       key: "13-4-1",
          //       label: "Trip Report",
          //       path: "/AItripreport",
          //       SECCODE: "AITRPT",
          //     },
          //     {
          //       key: "13-4-2",
          //       label: "Vehicle Report",
          //       path: "/AIvehiclereport",
          //       SECCODE: "AIVRPT",
          //     },
          //     {
          //       key: "6-4-3",
          //       label: "Customer Report",
          //       path: "/AIcustomerreport",
          //       SECCODE: "AICUSTRPT",
          //     },
          //     {
          //       key: "13-4-4",
          //       label: "KPI Report",
          //       path: "/AIkpi report",
          //       SECCODE: "AIKPI_RPT",
          //     },
          //     {
          //       key: "13-4-5",
          //       label: "Trip Break Report",
          //       path: "/AITripbreakreport",
          //       SECCODE: "AITRBRPT",
          //     },
          //     {
          //       key: "13-4-6",
          //       label: "Trip Allowance",
          //       path: "/AITripAllowance",
          //       SECCODE: "AITARPT",
          //     },
          //     {
          //       key: "13-4-7",
          //       label: "Carbon Footprint",
          //       path: "/AICarbonfootprints",
          //       SECCODE: "AITCFRPT",
          //     },
          //     {
          //       key: "13-4-8",
          //       label: "Fuel Report",
          //       path: "/AIfuelreport",
          //       SECCODE: "AIFUELRPT",
          //     },
          //   ],
          // },
        ],
      },
    isNexusMenuUser &&
      (tripAIReportRead ||
        vehicleAIReportRead ||
        custAIReportRead ||
        carbonAIReportRead ||
        fuelAIReportRead ||
        tripAllAIReportRead ||
        kpiAIReportRead) && {
        key: "15",
        icon: <img src={OperationIcon} alt="Nexus reports" />,
        label: "Nexus - AI Reports",
        path: "",
        SECCODE: "",
        children: [
          tripAIReportRead && {
            key: "15-1",
            label: "Trip Report",
            path: "/nexusTripReport",
            SECCODE: "AITRPT",
          },
          vehicleAIReportRead && {
            key: "15-3",
            label: "Vehicle Report",
            path: "/nexusVehicleReport",
            SECCODE: "AIVRPT",
          },
          custAIReportRead && {
            key: "15-4",
            label: "Customer Report",
            path: "/nexusCustomerReport",
            SECCODE: "AICUSTRPT",
          },

          tripAllAIReportRead && {
            key: "15-7",
            label: "Trip Allowance",
            path: "/nexusTripAllowanceReport",
            SECCODE: "AITARPT",
          },
          kpiAIReportRead && {
            key: "15-2",
            label: "KPI Report",
            path: "/nexusKpiReport",
            SECCODE: "AIKPI_RPT",
          },
          carbonAIReportRead && {
            key: "15-5",
            label: "Carbon Footprint",
            path: "/nexusCarbonReport",
            SECCODE: "AITCFRPT",
          },

          fuelAIReportRead && {
            key: "15-6",
            label: "Fuel Report",
            path: "/nexusFuelReport",
            SECCODE: "AIFUELRPT",
          },
        ],
      },
    // {
    //   key: "11",
    //   icon: <img src={AnalyticsIcon} alt="analytics" />,
    //   label: "Analytics",
    //   path: "/analytics",
    //   children: [
    //     {
    //       key: "11-1",
    //       label: "Dashbord",
    //       path: "/analytics/dashbord",
    //     },
    //     {
    //       key: "11-2",
    //       label: "Trend",
    //       path: "/Trend",
    //     },
    //     {
    //       key: "11-3",
    //       label: "Demographics",
    //       path: "/Demographics",
    //     },
    //     {
    //       key: "11-4",
    //       label: "Productivity",
    //       path: "/analytics/productivity",
    //     },
    //   ],
    // },
    // {
    //   key: "12",
    //   icon: <img src={NotificationIcon} alt="notification" />,
    //   label: "Notification",
    //   path: "/Notification",
    //   SECCODE: "",
    // },
  ].filter(Boolean);
  const menuItems = item.filter((i) => i && Object.keys(i).length > 0);

  const findMenuDetailsByPath = (menuItems, currentPath) => {
    for (const item of menuItems) {
      if (item?.children) {
        for (const child of item.children) {
          if (
            child?.path?.trim()?.toLowerCase() === currentPath?.toLowerCase()
          ) {
            return { key: child.key, label: child.label };
          }
        }
      } else {
        if (item?.path?.trim()?.toLowerCase() === currentPath?.toLowerCase()) {
          return { key: item.key, label: item.label };
        }
      }
    }
    return { key: "1", label: "Home" }; // default fallback
  };

  const { key: initialKey, label: initialHeading } = findMenuDetailsByPath(
    item,
    currentPath,
  );
  const [selectedKey, setSelectedKey] = useState(initialKey);
  console.log("initialKeyinitialHeading", initialKey, selectedKey);
  const [heading, setHeading] = useState(initialHeading);
  const [loading, setLoading] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [ResetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);
  const subscriptionList = useSelector(
    (state) => state?.authTracking?.subscriptionList,
  );
  console.log("subscrption--->", subscriptionList);

  const menuData = useMemo(() => {
    const top = item.filter((i) => i && Object.keys(i).length > 0);
    if (!userInfo?.MCID) return top;
    const codes = Array.isArray(subscriptionList) ? subscriptionList : [];
    return filterMenu(item, codes);
  }, [item, userInfo?.MCID, subscriptionList]);

  // const handleResetPassword =  (values) => {
  //   setResetPasswordModalOpen(true);
  // }
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!userInfo?.MCID) return;

    let cancelled = false;
    const fetchSubscriptions = async () => {
      setLoading(true);
      try {
        const res = await CALL_API(
          "GET",
          `subscription/getById?McID=${userInfo.MCID}`,
        );
        const rows = parseSubscriptionRows(res);
        const subscriptionSecCodes = rows
          .map((sub) => sub.SECCODE?.trim()?.toUpperCase())
          .filter(Boolean);

        if (!cancelled) {
          dispatch(setSubscriptionList(subscriptionSecCodes));
        }
      } catch (error) {
        console.error("[fetchSubscriptions] error:", error);
        if (!cancelled) {
          dispatch(setSubscriptionList([]));
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchSubscriptions();
    return () => {
      cancelled = true;
    };
  }, [userInfo?.MCID, dispatch]);

  //reset password integration
  const [form] = Form.useForm();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); //  No conflict

  const [openKeys, setOpenKeys] = useState([]);
  console.log("setOpennkey", openKeys);

  // ensures only one submenu open at a time
  // const handleOpenChange = (keys) => {
  //   const latestOpenKey = keys.find((key) => !openKeys.includes(key));
  //   setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  // };

  const handleOpenChange = (keys) => {
    console.log("key1s", keys);
    console.log("key1s", openKeys);

    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    console.log("lastopenkeys-->", latestOpenKey);
    // setOpenKeys(
    //   latestOpenKey === "6-4"
    //     ? ["6", "6-4", "7", "7-4"]
    //     : latestOpenKey
    //     ? [latestOpenKey]
    //     : []
    // );
    if (latestOpenKey?.includes("-")) {
      const prevkey = latestOpenKey[0];
      setOpenKeys(latestOpenKey ? [prevkey, latestOpenKey] : []);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const handleResetPassword = async () => {
    setLoading(true);
    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `reset-password?UID=${userInfo?.UID}`,
        {
          currentPassword: currentPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword,
        },
      );

      if (ResponseCode === 200) {
        message.success(data || "Password reset done successfully");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        form.resetFields();
        setResetPasswordModalOpen(false);
      } else if (ResponseCode === 400) {
        message.warning(data || "Password reset failed");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        form.resetFields();
      } else {
        message.error(data || "Password reset failed");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        form.resetFields();
      }
    } catch (error) {
      message.error("Something went wrong");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const findMenuItem = (menus, key) => {
    for (const item of menus) {
      if (item.key === key) return item;
      if (item.children) {
        const found = findMenuItem(item.children, key);
        if (found) return found;
      }
    }
    return null;
  };
  // const handleMenuClick = ({ key }) => {
  //   console.log(key, "key123");
  //   console.log("Menuclicked", key?.split("-")?.[1]);
  //   const parentItem = menuData.filter((menu) => {
  //     return (
  //       menu.key === key ||
  //       menu.children?.some((sub) => sub.key === key) ||
  //       menu.children
  //         ?.find(
  //           (sub) =>
  //             sub.key === `${key?.split("-")?.[0]}-${key?.split("-")?.[1]}`
  //         )
  //         ?.children?.some((sub) => sub.key === key)
  //     );
  //   });

  //   console.log("parentItem-->", parentItem);

  //   if (parentItem) {
  //     if (parentItem.key === key) {
  //       navigate(parentItem.path);
  //       setHeading(parentItem.label);
  //     } else if (parentItem.children.find((sub) => sub.key === key)) {
  //       console.log("working");
  //       const childItem = parentItem.children.find((sub) => sub.key === key);
  //       navigate(childItem.path);
  //       setHeading(childItem.label);
  //     } else if (
  //       parentItem.children
  //         .find(
  //           (sub) =>
  //             sub.key === `${key?.split("-")?.[0]}-${key?.split("-")?.[1]}`
  //         )
  //         ?.children?.some((sub) => sub.key === key)
  //     ) {
  //       console.log("working1");
  //       const childItem = parentItem.children
  //         .find(
  //           (sub) =>
  //             sub.key === `${key?.split("-")?.[0]}-${key?.split("-")?.[1]}`
  //         )
  //         ?.children?.some((sub) => sub.key === key);
  //       setSelectedKey(key);
  //       navigate(childItem.path);
  //     }
  //   }
  // };
  const handleMenuClick = ({ key }) => {
    console.log(key, "keykeykey");
    // 1️⃣ find parent menu
    const parent = menuData.find(
      (menu) =>
        menu.key === key ||
        menu.children?.some((c) => c.key === key) ||
        menu.children?.some((c) => c.children?.some((g) => g.key === key)),
    );

    if (!parent) return;

    // 2️⃣ check if clicked is parent
    if (parent.key === key) {
      navigate(parent.path);
      setHeading(parent.label);
      setSelectedKey(key);
      return;
    }

    // 3️⃣ check first-level child
    const child = parent.children?.find((c) => c.key === key);
    if (child) {
      navigate(child.path);
      setHeading(child.label);
      setSelectedKey(key);
      return;
    }

    // 4️⃣ check second-level child (grandchild)
    let grandchild;
    parent.children?.forEach((c) => {
      const gc = c.children?.find((g) => g.key === key);
      if (gc) grandchild = gc;
    });

    if (grandchild) {
      navigate(grandchild.path);
      setHeading(grandchild.label);
      setSelectedKey(key);
    }
  };

  const [islogoVisible, setIslogoVisible] = useState(true);
  const handlevisible = () => {
    setIslogoVisible(!islogoVisible);
  };

  const handleLogoClick = () => {
    setSelectedKey("1");
    setHeading("Home");
    navigate("/Home");
  };

  const handleclickloouttoken = () => {
    window?.localStorage?.removeItem("token");
    window.location.href = "https://www.v2.trackright.africa/"; //website url
  };
  const location = useLocation();
  const hideOverflowPages = ["/liveTrackingMaincontainer"];
  const isOverflowHidden = hideOverflowPages.includes(location.pathname);
  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        icon={<LockOutlined />}
        onClick={() => setResetPasswordModalOpen(true)}
      >
        Reset Password
      </Menu.Item>
      <Menu.Item
        key="2"
        icon={<LogoutOutlined />}
        onClick={handleclickloouttoken}
      >
        Sign Out
      </Menu.Item>
    </Menu>
  );

  return (
    <LayoutWrap>
      <Layout>
        {!isMobile &&
          !hideLayout &&
          !hideAILayout &&
          !hideContainerLayout &&
          !hideNexusLayout && (
            <Sider
              trigger={null}
              collapsible
              collapsed={collapsed}
              className="side-bar"
              width={250}
              style={{
                flex: "0 0 250px",
              }}
            >
              <div className="demo-logo-vertical" />
              <Link
                to="/Home"
                onClick={() => {
                  handleLogoClick();
                  handlevisible();
                  setCollapsed(!collapsed);
                }}
              >
                <div className="ab">
                  <img
                    className="logo_Style "
                    src={collapsed ? logohead : TrackRightLogo}
                    alt="TrackRight"
                  />
                </div>
              </Link>

              {console.log(selectedKey, "selectedKey")}

              <Menu
                theme="dark"
                mode="inline"
                style={{ height: "88vh", overflowY: "scroll" }}
                selectedKeys={[selectedKey]}
                onClick={handleMenuClick}
                openKeys={openKeys}
                onOpenChange={handleOpenChange}
                items={menuData}
                className="menustyle"
              />
              <UIModal
                open={ResetPasswordModalOpen}
                size="550px"
                closeButton={false}
                onClose={() => setResetPasswordModalOpen(false)}
                footer={null}
                centered={true}
              >
                <h3 style={{ color: "#5F6D8C", padding: "5px" }}>
                  Reset Password
                </h3>
                <Form layout="vertical" form={form}>
                  <Form.Item
                    name="CurrentPassword"
                    label="Current Password"
                    rules={[{ message: "Please enter your current password" }]}
                    style={{ color: "#5F6D8C" }}
                  >
                    <Input.Password
                      placeholder="Enter current password"
                      className="reset-input"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item
                    name="newPassword"
                    label="New Password"
                    rules={[{ message: "Please enter a new password" }]}
                    style={{ color: "#5F6D8C" }}
                  >
                    <Input.Password
                      placeholder="Enter new password"
                      value={newPassword}
                      className="reset-input"
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item
                    name="confirmPassword"
                    label="Confirm Password"
                    dependencies={["newPassword"]}
                    style={{ color: "#5F6D8C" }}
                    rules={[
                      { message: "Please confirm your password" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue("newPassword") === value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords do not match"),
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      placeholder="Confirm new password"
                      className="reset-input"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item>
                    <ButtonFilled
                      htmlType="submit"
                      style={{ fontSize: "12px" }}
                      loading={loading}
                      onClick={handleResetPassword}
                      disabled={loading}
                    >
                      Reset Password
                    </ButtonFilled>
                  </Form.Item>
                </Form>
              </UIModal>
            </Sider>
          )}
        <Layout>
          {!hideLayout &&
            !hideAILayout &&
            !hideContainerLayout &&
            !hideNexusLayout && (
              <Header
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#F1F1F1",
                  border: "none",
                  padding: "0 16px",
                }}
              >
                {/* Left: Hamburger / Collapse Button */}
                <div
                  style={{
                    flex: "0 0 auto",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {isMobile ? (
                    <Button
                      type="text"
                      icon={<MenuOutlined />}
                      onClick={() => setDrawerVisible(true)}
                      style={{ fontSize: "20px", color: "#2c963d" }}
                    />
                  ) : (
                    <Button
                      type="text"
                      icon={collapsed ? <LeftOutlined /> : <RightOutlined />}
                      onClick={() => setCollapsed(!collapsed)}
                      style={{
                        color: "#2c963d",
                        borderRadius: "50px",
                        border: "3px solid #FFFFFF",
                        backgroundColor: "#D0D5DD",
                      }}
                    />
                  )}
                </div>

                {/* Center: Title */}
                <div
                  style={{
                    flex: "1 1 auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  <h4
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                    }}
                    title={heading}
                  >
                    {heading}
                  </h4>
                </div>

                {/* Right: Profile / Icons */}
                <div
                  style={{
                    flex: "0 0 auto",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  {/* Example icons */}
                  {window.innerWidth >= 320 &&
                  window.innerWidth <= 426 ? null : (
                    <>
                      {/* <Tooltip title="AI Co-Pilot">
                      <div
                        onClick={() => navigate("/AIChat")}
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #2C963D, #1a6b28)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          boxShadow: "0 2px 8px rgba(44,150,61,0.4)",
                          flexShrink: 0,
                        }}
                      >
                        <RobotOutlined
                          style={{ color: "#fff", fontSize: 16 }}
                        />
                      </div>
                    </Tooltip> */}
                      <img src={alert} />
                      <img src={notify} onClick={handleClicknotify} />
                    </>
                  )}

                  <Dropdown overlay={menu} trigger={["click"]}>
                    <div style={{ cursor: "pointer" }}>
                      {window.innerWidth >= 320 &&
                      window.innerWidth <= 426 ? null : (
                        <img
                          src={profile}
                          alt="Profile"
                          style={{ cursor: "pointer", marginLeft: "15px" }}
                        />
                      )}
                      {window.innerWidth >= 320 && window.innerWidth <= 426 ? (
                        <>
                          <img src={ProfileIconresponive} alt="Profile" />
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Dropdown>
                </div>
              </Header>
            )}

          {/* Drawer for Mobile Menu */}
          <Drawer
            title={
              <img
                src={trackrightlogo} // Replace with your image path
                alt="Menu"
                style={{ height: "25px" }} // Adjust size as needed
              />
            }
            placement="left"
            width={200}
            onClose={() => setDrawerVisible(false)}
            visible={drawerVisible}
            closeIcon={
              <CloseOutlined style={{ color: "white", fontSize: "18px" }} />
            }
            bodyStyle={{ backgroundColor: "#001529", padding: "0" }} // Match sidebar theme
            headerStyle={{ backgroundColor: "#001529", color: "#fff" }}
          >
            <Menu
              theme="dark"
              style={{ height: "88vh", overflowY: "scroll" }}
              mode="inline"
              selectedKeys={[selectedKey]}
              // onClick={({ info }) => {
              //   handleMenuClick(info);
              //   setDrawerVisible(false);
              // }}
              onClick={(info) => {
                handleMenuClick(info); // Pass the full object
                setDrawerVisible(false);
              }}
              // items={item}
              items={menuData}
              className="menustyle"
            />
          </Drawer>

          <Content
            className="main-content p-3"
            style={{ overflowY: isOverflowHidden ? "hidden" : "auto" }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </LayoutWrap>
  );
};

export default Mainindex;
